<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Pneumocócica 10V (conjugada)"
            description="Situação vacinal de pessoas com Pneumocócica 10V (conjugada)"
            url="/imunizacao/vacina-idade-certa"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Pneumocócica 10V (conjugada)',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
